export const INCOME_TYPE = {
  HOSPITAL_REPORT: {
    value: "Reporte hospitalario",
    label: "Reporte hospitalario"
  },
  SCHEDULED_SURGERY: {
    value: "Programacion de cirugia",
    label: "Programación de cirugía"
  },
};